export default defineNuxtRouteMiddleware(to => {
  if (to.path.replace(/\/+$/, '') === '/feed/1353') {
    return navigateTo('/feed', { redirectCode: 301, replace: true });
  }
});
